import React from "react";
import { Link } from "react-router-dom";
import {
  LocationMarkerIcon,
  CalendarIcon,
  UserGroupIcon,
} from "@heroicons/react/solid"; // Tailwind Heroicons
import bgImage from "../../../assets/img/frontend/hero_section_2.jpg";

const guests = [
  { value: "1 person", label: "1 person" },
  { value: "2 person", label: "2 person" },
  { value: "3+ person", label: "3+ persons" },
];

const HeroSection = () => {
  return (
    <section
      className="relative flex h-screen items-center justify-center rounded-b-[50px] bg-cover bg-center px-4 md:px-8"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Overlay to darken bg for better text contrast */}
      <div className="absolute inset-0 rounded-b-[50px] bg-black bg-opacity-20"></div>

      <div className="relative z-10 max-w-[1200px] text-center text-white">
        <h1 className="text-lg leading-snug md:text-5xl lg:text-3xl lg:font-bold">
          Find Your Ideal Escape –
          <br />
          Reserve Elegant Accommodations in Breathtaking Locations
        </h1>
        <p className="mx-auto mt-4 max-w-xl text-sm font-light">
          Discover top-tier hotels and resorts, handpicked to ensure a memorable
          and effortless journey.
        </p>

        {/* Search Form */}
        <form
          className="mx-5 mt-8 rounded-2xl bg-white p-6 shadow-lg md:p-8"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="flex flex-col gap-6 lg:grid lg:grid-cols-5 lg:gap-6">
            {/* Location - always first row */}
            <div className="flex w-full flex-col items-start">
              <label className="mb-1 font-semibold text-gray-700">
                Location
              </label>
              <div className="relative w-full">
                <LocationMarkerIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 transform text-brand-700" />
                <input
                  type="text"
                  placeholder="New York, USA"
                  className="w-full rounded-full border border-gray-300 py-2 pl-10 pr-3 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                />
              </div>
            </div>

            {/* Check-in & Check-out - side by side on small, separate on large */}
            <div className="flex w-full flex-row gap-6 lg:col-span-2">
              <div className="flex w-1/2 flex-col items-start lg:w-full">
                <label className="mb-1 font-semibold text-gray-700">
                  Check-in
                </label>
                <div className="relative w-full">
                  <CalendarIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 transform text-brand-700" />
                  <input
                    type="date"
                    className="w-full rounded-full border border-gray-300 py-2 pl-10 pr-3 text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </div>
              </div>
              <div className="flex w-1/2 flex-col items-start lg:w-full">
                <label className="mb-1 font-semibold text-gray-700">
                  Check-out
                </label>
                <div className="relative w-full">
                  <CalendarIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 transform text-brand-700" />
                  <input
                    type="date"
                    className="w-full cursor-pointer rounded-full border border-gray-300 py-2 pl-10 pr-3 text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </div>
              </div>
            </div>

            {/* Guest - always below on small screens, in correct grid position on large */}
            <div className="flex w-full flex-col items-start lg:col-span-1">
              <label className="mb-1 font-semibold text-gray-700">Guest</label>
              <div className="relative w-full rounded-full border border-gray-300">
                <UserGroupIcon className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 transform text-brand-700" />
                <select
                  defaultValue="2 person"
                  className="w-full appearance-none rounded-full py-2 pl-10 pr-3 text-[#000] focus:outline-none"
                >
                  {guests.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Search Button - in same row on large screens */}
            <div className="hidden lg:flex lg:flex-col lg:items-start lg:justify-end">
              <Link
                to="/hotels"
                className="block min-w-[150px] rounded-full bg-indigo-900 px-6 py-3 text-center font-medium text-white transition-colors hover:bg-indigo-700"
              >
                Search Hotels
              </Link>
            </div>
          </div>

          {/* Search Button - separate row for small screens */}
          <div className="mt-6 flex justify-center lg:hidden">
            <Link
              to="/hotels"
              className="block min-w-[150px] rounded-full bg-indigo-900 px-6 py-3 text-center font-medium text-white transition-colors hover:bg-indigo-700"
            >
              Search Hotels
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
};

export default HeroSection;
